import type { App } from 'vue'
import tooltip from './tooltip'
import { loading } from './loadingDirective'

const setupMixin = (app: App) => {
  app.mixin(tooltip)
  app.directive('loading', loading)
}

export default setupMixin
